// extracted by mini-css-extract-plugin
export default {"tagLine":"Header_tagLine__34pMZ","header":"Header_header__FE5Vg"};